/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

export const focusById = (id: string) => {
  const selectedElement = document.querySelector(`#${id}`);
  if (!selectedElement) {
    //   TODO: Error reporting here
    return;
  }
  (selectedElement as HTMLElement).focus();
};
